import { z } from 'zod';

import { StandardisedSectionName } from '../../@types/types';

import type { PK } from './database.schema';
import { baseDatabaseSchema } from './database.schema';

export const SectionSchema = z.object({
  label: z.string(),
  layout: z.array(z.string()).default([]),
  should_hide_title_in_pdf: z.boolean().optional(),
  should_reset_page_counter: z.boolean().optional(),
  standardised_name: z.nativeEnum(StandardisedSectionName).optional(),
  // to be removed
  parentSectionId: z.string().optional(),
});
export const DbSectionSchema = SectionSchema.merge(baseDatabaseSchema);

export const sectionDatabaseSchema = SectionSchema.merge(baseDatabaseSchema);

export type Section = z.infer<typeof SectionSchema>;
export type SectionDb = z.infer<typeof sectionDatabaseSchema> & PK;
